"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var RetryStrategy = /** @class */ (function () {
    function RetryStrategy() {
        var _this = this;
        this.strategy = function (options) { return function (attempts) {
            return attempts.pipe(operators_1.mergeMap(function (error, i) {
                var retryAttempt = i + 1;
                // if maximum number of retries have been met
                // or response is a status code we don't wish to retry, throw error
                if (retryAttempt > options.maxRetryAttempts) {
                    // request cannot be retried anymore
                    return rxjs_1.throwError(error);
                }
                var statusCode = 0;
                if (error && error.originalError && error.originalError.response && error.originalError.response.status) {
                    statusCode = error.originalError.response.status;
                }
                // check if request can be retried by looking into allowed retry status codes
                if (!options.useRetryForResponseCodes.find(function (m) { return m === statusCode; })) {
                    // request cannot be retried
                    return rxjs_1.throwError(error);
                }
                // calculate retry time
                var retryTimeout = _this.getRetryTimeout(retryAttempt);
                // debug log attempt
                _this.debugLogAttempt(retryAttempt, retryTimeout);
                return rxjs_1.timer(retryTimeout);
            }));
        }; };
    }
    /**
    * Calculates retry attempt timeout in ms
    * @param attempt Index of the attempt to calculate increasing delay when retrying
    */
    RetryStrategy.prototype.getRetryTimeout = function (attempt) {
        return Math.pow(2, attempt) * 100;
    };
    /**
     * Logs attempt in console.
     * This function is also used for testing in jasmine spy
     * @param attempt Index of attempt
     */
    RetryStrategy.prototype.debugLogAttempt = function (attempt, retryTimeout) {
        console.warn("Attempt " + attempt + ": retrying in " + retryTimeout + "ms");
    };
    return RetryStrategy;
}());
exports.RetryStrategy = RetryStrategy;
exports.retryStrategy = new RetryStrategy();
//# sourceMappingURL=retry-strategy.js.map